import { initializeApp, type FirebaseApp } from 'firebase/app'
import {
  browserLocalPersistence,
  getAuth,
  setPersistence,
  GoogleAuthProvider,
  type Auth,
} from 'firebase/auth'
import { getFirestore, type Firestore } from 'firebase/firestore'
import { readFirebaseEnv } from '@/lib/env'

const { config, missing } = readFirebaseEnv()

/** Non-empty when .env.local is incomplete; the UI shows a setup screen instead of crashing. */
export const firebaseConfigErrors = missing

let app: FirebaseApp | null = null
let authInstance: Auth | null = null
let dbInstance: Firestore | null = null

if (config) {
  app = initializeApp(config)
  authInstance = getAuth(app)
  dbInstance = getFirestore(app)
  // Keep the admin signed in across reloads; sign-out is explicit.
  void setPersistence(authInstance, browserLocalPersistence)
}

export const isFirebaseReady = app !== null

export function getAuthOrThrow(): Auth {
  if (!authInstance) throw new Error('Firebase is not configured: check web/.env.local')
  return authInstance
}

export function getDbOrThrow(): Firestore {
  if (!dbInstance) throw new Error('Firebase is not configured: check web/.env.local')
  return dbInstance
}

/** Google is the only sign-in method of the console — same provider as the Android app. */
export function googleProvider(): GoogleAuthProvider {
  const provider = new GoogleAuthProvider()
  // Always let the admin pick the account instead of silently reusing the last one.
  provider.setCustomParameters({ prompt: 'select_account' })
  return provider
}
